import React, { Component } from 'react';
import queryString from 'query-string';
import { checkJiraStatus } from '../../utils/utils';
import {
  getOAuthAccessTokensForUsers,
  getAccessTokens,
  addGlobalGuestToken,
  getCurrentSkill,
} from '../skills/skills_action';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
class JiraoauthCallback extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.skills.length !== prevProps.skills.length) {
      const { skills } = this.props;
      const jiraSkill = skills.find((skill) => skill.name === 'Jira');
      const isJiraEnabled =
        jiraSkill && jiraSkill.skill_metadata
          ? checkJiraStatus(jiraSkill.skill_metadata)
          : true;

      let code = queryString.parse(this.props.location.search);
      // let oauthToken=code.oauth_token
      let oauthverifier = code.oauth_verifier;
      if (code.isUser) {
        if (oauthverifier === 'denied') {
          if (
            !isJiraEnabled /* jiraSkill && jiraSkill.skill_metadata.disabled */
          )
            this.props.history.push(
              `/${this.props.match.params.wId}/teamsyncs/integrations/${this.props.match.params.skill_id}`
            );
          else
            this.props.history.push(
              `/${this.props.match.params.wId}/skills/${this.props.match.params.skill_id}/${code.sub_skill}?view=personal_preferences`
            );
        } else {
          this.props
            .getOAuthAccessTokensForUsers(
              this.props.match.params.wId,
              oauthverifier,
              code.sessionid
            )
            .then((res) => {
              if (res && res.data && res.data.success) {
                // if(jiraSkill && jiraSkill.skill_metadata.disabled)
                // this.props.history.push(`/${this.props.match.params.wId}/teamsyncs/integrations/${this.props.match.params.skill_id}`)
                // else
                // this.props.history.push(`/${this.props.match.params.wId}/skills/${this.props.match.params.skill_id}?view=personal_preferences`)

                this.props.history.push(
                  '/' +
                    this.props.match.params.wId +
                    '/jira_user_welcome/' +
                    this.props.match.params.skill_id +
                    `?sub_skill=${code.sub_skill}`
                );
              } else {
              }
            });
        }
      } else {
        if (oauthverifier === 'denied') {
          // v2.1: consent cancelled -> back to where it started, not legacy.
          if (code.from === 'onboarding') {
            window.location.href = '/v2/onboarding';
            return;
          }
          if (code.from === 'connections') {
            window.location.href = `/v2/${this.props.match.params.wId}/connections?jira=denied`;
            return;
          }
          if (
            !isJiraEnabled /* jiraSkill && jiraSkill.skill_metadata.disabled */
          )
            this.props.history.push(
              `/${this.props.match.params.wId}/teamsyncs/integrations/${this.props.match.params.skill_id}`
            );
          else
            this.props.history.push(
              `/${this.props.match.params.wId}/skills/${this.props.match.params.skill_id}/${code.sub_skill}?view=connection`
            );
        } else {
          this.props
            .getAccessTokens(
              this.props.match.params.wId,
              oauthverifier,
              code.sessionid
            )
            .then(async (response) => {
              if (response.data.success) {
                // Initiated from the onboarding wizard → return there.
                if (code.from === 'onboarding') {
                  this.props.history.push('/onboarding?jira=connected');
                  return;
                }
                if (code.sub_skill === 'jira_service_desk') {
                  await this.props.addGlobalGuestToken(
                    this.props.match.params.wId,
                    this.props.match.params.skill_id
                  );
                  let query = 'sId=' + this.props.match.params.skill_id;
                  this.props.getCurrentSkill(
                    this.props.match.params.wId,
                    query
                  ); /* TODO : juggard to update the store  should be handled properly*/
                }
                // v2.1 (new UI at /v2): return to wherever the connect started
                // instead of the legacy jiraConnectionSteps page. A full reload
                // crosses apps. onboarding → the wizard (re-checks via
                // ?jira=connected); connections → the Connections page.
                if (code.from === 'onboarding') {
                  window.location.href = '/v2/onboarding?jira=connected';
                  return;
                }
                if (code.from === 'connections') {
                  window.location.href = `/v2/${this.props.match.params.wId}/connections?jira=connected`;
                  return;
                }
                let skill = response.data.skill;
                // const url = `${window.location.origin}/${this.props.match.params.wId}/jiraConnectionSteps/${this.props.match.params.skill_id}?domainName=${skill.metadata.domain_url}&sub_skill=${code.sub_skill}`;
                // window.open(url, "_self");
                this.props.history.push(
                  '/' +
                    this.props.match.params.wId +
                    '/jiraConnectionSteps/' +
                    this.props.match.params.skill_id +
                    `?domainName=${skill.metadata.domain_url}&sub_skill=${code.sub_skill}`
                );
                // this.props.history.push(`/${this.props.match.params.wId}/skills/${this.props.match.params.skill_id}`)
              } else {
              }
            });
        }
      }
      //     let response=await getAccessTokens(this.props.match.params.wId,oauthverifier)
      // if(response.success){
      // this.props.history.push(`/${this.props.match.params.wId}/skills/${this.props.match.params.skill_id}`)
      // }
      // else{

      // }
      // }
    }
  }
  render() {
    // Full-screen loader that covers the legacy app shell while the token
    // exchange runs (~a few seconds), then we redirect to /v2. Without this the
    // user briefly sees the old app's sidebar + blank content ("why the old
    // UI"). Neutral branded screen instead.
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          zIndex: 99999,
          background: '#ffffff',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 14,
        }}
      >
        <div
          style={{
            width: 36,
            height: 36,
            borderRadius: '50%',
            border: '3px solid #e6e8ee',
            borderTopColor: '#5039BB',
            animation: 'tprJiraSpin 0.8s linear infinite',
          }}
        />
        <div style={{ fontSize: 16, fontWeight: 600, color: '#131a24' }}>
          Finishing your Jira connection…
        </div>
        <div style={{ fontSize: 14, color: '#6b7480' }}>
          Just a moment while we link your account.
        </div>
        <style>{`@keyframes tprJiraSpin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    skills: store.skills.skills,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    getOAuthAccessTokensForUsers,
    getAccessTokens,
    addGlobalGuestToken,
    getCurrentSkill,
  })(JiraoauthCallback)
);
